import {inject, injectable} from "inversify";
import {SelectQueryBuilder} from "typeorm";
import type {QueryFilterFormInterface, QueryFilterInterface} from "@/modules/vue/interfaces";
import {Player} from "@/modules/team/entity";
import {PlayerQueryFilterForm} from "./PlayerQueryFilterForm";
import {PositionEnum} from "@/modules/base/enums";

type RangeType = [number, number];
type TalentStepType = 1 | 2 | 3 | 4 | 5 | 6 | 7;

type FormType = {
  skill: RangeType,
  age: RangeType,
  positions: PositionEnum[],
  canAffordOnly: boolean,
  knownTalentsOnly: boolean,
  talent: [TalentStepType, TalentStepType],
}

@injectable()
export class PlayerQueryFilter implements QueryFilterInterface<Player> {
  constructor(
    @inject(PlayerQueryFilterForm) private filterForm: QueryFilterFormInterface
  ) {}

  apply(query: SelectQueryBuilder<Player>, form: FormType): SelectQueryBuilder<Player> {
    query.andWhere(
      'player.age >= :ageFrom AND player.age <= :ageTo',
      {ageFrom: form.age[0], ageTo: form.age[1]}
    );
    query.andWhere(
      'player.skill >= :skillFrom AND player.skill <= :skillTo',
      {skillFrom: form.skill[0], skillTo: form.skill[1] < 100 ? form.skill[1] : 200}
    );

    if (form.positions.length > 0) {
      query.andWhere(`player.position IN ('${form.positions.join('\',\'')}')`);
    }

    if (form.canAffordOnly) {
      // todo
    }

    if (form.knownTalentsOnly) {
      query.andWhere(`player.revelation = 100`);
    }

    if (form.talent[0] > 1 || form.talent[1] < 7) {
      const mapping = {
        1: 20,
        2: 35,
        3: 50,
        4: 65,
        5: 80,
        6: 95,
        7: 100,
      };

      let talentFrom = 1;
      if (form.talent[0] > 1) {
        // @ts-ignore
        talentFrom = mapping[form.talent[0] - 1] + 1;
      }

      let talentTo = 200;
      if (form.talent[1] < 7) {
        talentTo = mapping[form.talent[1]];
      }

      query.andWhere(
        'player.revelation = 100 AND player.talent >= :talentFrom AND player.talent <= :talentTo',
        {talentFrom, talentTo}
      );
    }

    return query;
  }

  getForm(): QueryFilterFormInterface {
    return this.filterForm;
  }
}